import generateGenericInfoFromPerfCheckpoints from './generateGenericInfoFromPerfCheckpoints';
import generateTelemetryData from './generateTelemetryData';
import getConnectorsTokenAndLogTelemetry from '../service/getConnectorsTokenAndLogTelemetry';
import { TelemetryDetails } from 'owa-actionable-message';
import { logUsage } from 'owa-analytics';
import { MailboxType } from 'owa-client-ids';
import { trace } from 'owa-trace';

export default function logTelemetry(telemetryDetails: TelemetryDetails): string {
    const {
        mailboxInfo,
        eventName,
        cardDetails,
        messageContext,
        correlationVector,
        actionContext,
        perfCheckpoints,
    } = telemetryDetails;
    const isGroup = mailboxInfo.type === MailboxType.GroupMailbox;

    let genericInfo: string;
    if (perfCheckpoints) {
        try {
            genericInfo = generateGenericInfoFromPerfCheckpoints(perfCheckpoints);
        } catch (e) {
            trace.warn(
                `Actionable Message Cards: exception when calculating genericInfo datapoint: ${e.message}`
            );
        }
    }

    const telemetryInfo = generateTelemetryData(
        eventName,
        cardDetails,
        isGroup,
        messageContext,
        correlationVector,
        genericInfo
    );

    telemetryInfo.connectorSenderGuid = cardDetails.connectorSenderGuid;

    if (actionContext) {
        telemetryInfo.actionContext = actionContext;
    }

    logUsage(`AdaptiveCardLogger-${eventName}`, { CorrelationVector: correlationVector });
    getConnectorsTokenAndLogTelemetry(
        telemetryInfo,
        isGroup ? mailboxInfo.mailboxSmtpAddress : null
    );
    trace.info('[logTelemetry] Log telemetry triggered');

    return telemetryInfo.correlationVector;
}
